import { Link } from "react-router-dom";
import { Zap } from "lucide-react";
import { Footer } from "./Footer";

export function PublicPage({ title, subtitle, children, testid = "public-page" }) {
  return (
    <div className="min-h-screen bg-[#0A0A0C] text-zinc-100 flex flex-col" data-testid={testid}>
      <header className="border-b border-zinc-900">
        <div className="max-w-4xl mx-auto px-4 h-16 flex items-center justify-between">
          <Link to="/login" className="flex items-center gap-2" data-testid="public-logo">
            <div className="w-9 h-9 rounded-xl gold-gradient flex items-center justify-center">
              <Zap className="w-5 h-5 text-black" fill="black" />
            </div>
            <span className="font-display font-extrabold text-xl">
              Cehn<span className="gold-text">ura</span>
            </span>
          </Link>
          <Link to="/login" className="text-sm text-zinc-400 hover:text-amber-400 transition-colors" data-testid="public-login-link">
            Connexion
          </Link>
        </div>
      </header>
      <main className="flex-1 max-w-3xl w-full mx-auto px-4 py-12">
        {title && (
          <h1 className="font-display text-3xl sm:text-4xl font-bold mb-2" data-testid="public-page-title">
            {title}
          </h1>
        )}
        {subtitle && <p className="text-zinc-500 mb-8">{subtitle}</p>}
        <div className="space-y-5 text-zinc-300 text-sm leading-relaxed">{children}</div>
      </main>
      <Footer />
    </div>
  );
}

export function LegalSection({ heading, children }) {
  return (
    <section className="space-y-2">
      <h2 className="text-lg font-semibold text-zinc-100 mt-6">{heading}</h2>
      <div className="space-y-2 text-zinc-400">{children}</div>
    </section>
  );
}
